function objectToStyle (styles) {
    return Object.entries(styles)
        .map(([key, value]) => `${key}:${value}`)
        .join(';');
}

export { objectToStyle as default };
//# sourceMappingURL=objectToStyle.js.map
